import z from "zod";

const zFloorAreaSchema = z
  .number()
  .positive()
  .max(2 ** 16)
  .brand("FloorArea");
type FloorAreaSchema = z.infer<typeof zFloorAreaSchema>;

export { zFloorAreaSchema };
export type { FloorAreaSchema as FloorArea, FloorAreaSchema };
